var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 23.3636L11.0002 16.9996M11.0002 16.9996L13.7844 19.7839M11.0002 16.9996L8.21592 19.7839",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23H23.5C24.6046 23 25.5 22.1046 25.5 21V16V13.5C25.5 12.3954 24.6046 11.5 23.5 11.5H18.313C18.0411 11.5 17.781 11.3893 17.5925 11.1935L15.5901 9.11305C15.213 8.72134 14.6928 8.5 14.1491 8.5H10C8.89543 8.5 8 9.39543 8 10.5V12.5",
    stroke: "#242424",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 20,
    r: 5.5,
    stroke: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 6V6C10.8696 5.16727 11.6694 4.61834 12.5049 4.76602L23.9382 6.78693C25.0077 6.97596 25.7309 7.98394 25.5673 9.0576L25.4999 9.5",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.44212dc0cbaf3ff3c19313be653c6f16.svg";
export { ForwardRef as ReactComponent };